/**
 *  OFFICE 파일 정규식 패턴 리스트
 */
export const OFFICE_FILE_REX_PATTERN_LIST = [
  /application\/pdf/,
  /application\/vnd.ms-excel/,
  /application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet/,
  /application\/msword/,
  /application\/vnd.openxmlformats-officedocument.wordprocessingml.document/,
  /application\/vnd.ms-powerpoint/,
  /application\/vnd.openxmlformats-officedocument.presentationml.presentation/,
];

/**
 *  이미지 크롭 영역에 초기 랜더링 될 이미지의 scale
 */
export const INIT_IMG_SCALE_OF_IMG_CROPPER_CONTAINER = 0.375;

/**
 *  이미지 크롭 영역의 너비
 */
export const CROPPER_CONTAINER_WIDTH = 600;

/**
 *  이미지 크롭 영역의 높이
 */
export const CROPPER_CONTAINER_HEIGHT = 400;

/**
 *   이미지 크롭 영역의 최대 줌 인 scale
 */
export const MAXIMUM_SCALE_OF_IMG_CROPPER_CONTAINER = 1.5;

/**
 *  테이블 컬럼의 글자 너비
 */
export const COLUMN_TEXT_WIDTH_SPACING = 10;

/**
 *  테이블 컬럼 최소 너비
 */
export const COLUMN_MIN_WIDTH = 100;

/**
 *  빠른 날짜 선택 버튼 대상
 */
export const QUICK_DATE_SELECT_BUTTON_TARGET = {
  /**
   *  시작일자
   */
  START_DATE: 0,
  /**
   *  종료일자
   */
  END_DATE: 1,
};

/**
 *  기간 검색 전체 버튼 타입
 */
export const SEARCH_PERIOD_BUTTON_ALL_TYPE = -1;

/**
 *  엑셀 다운로드를 할 데이터가 없을 경우 보여주는 문구
 */
export const NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT = '엑셀을 다운로드할 데이터가 없습니다.';

/**
 *  검색어는 두 글자 이상입니다.
 */
export const INVALID_MINIMUM_SEARCH_WORD_MESSAGE = '검색어는 두 글자 이상입니다.';

/**
 *  회원 타입
 */
export const AMONDZ_MEMBER_TYPE = {
  /**
   *  판매자
   */
  SELLER: 0,
  /**
   *  유저
   */
  USER: 1,
  /**
   *  관리자
   */
  ADMIN: 2,
  /**
   *  수취인
   */
  RECIPIENT: 3,
};

/**
 *  페이지 사이즈 리스트
 */
export const PAGE_SIZE_OPTIONS = ['20', '50', '100', '500'];

/**
 *  회원 타입 TEXT
 */
export const AMONDZ_MEMBER_TYPE_TEXT = {
  [AMONDZ_MEMBER_TYPE.SELLER]: '판매자',
  [AMONDZ_MEMBER_TYPE.USER]: '유저',
  [AMONDZ_MEMBER_TYPE.ADMIN]: '관리자',
  [AMONDZ_MEMBER_TYPE.RECIPIENT]: '수취인',
};

/**
 *  날짜 포맷
 */
export const DATE_FORMAT = {
  /**
   *  FULL 형태의 날짜 형식
   */
  FULL_KOREAN_FORMAT: 'YYYY년 MM월 DD일 HH시 mm분 ss초',
  /**
   *  YYYY년 MM월 DD일 형태의 날짜 형식
   */
  YMD_KOREAN_FORMAT: 'YYYY년 MM월 DD일',
  /**
   *  YYYY년 MM월 형태의 날짜 형식
   */
  YM_KOREAN_FORMAT: 'YYYY년 MM월',
  /**
   *  FULL DASH 형태의 날짜 형식
   */
  FULL_DASH_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  /**
   *  년-월-일 시:분 형태의 날짜 형식
   */
  YMD_HM_DASH_FORMAT: 'YYYY-MM-DD HH:mm',
  /**
   *  년-월-일 시 형태의 날짜 형식
   */
  YMD_H_DASH_FORMAT: 'YYYY-MM-DD HH',
  /**
   *  년-월-일 형태의 날짜 형식
   */
  YMD_DASH_FORMAT: 'YYYY-MM-DD',
  /**
   *  년-월 형태의 날짜 형식
   */
  YM_DASH_FORMAT: 'YYYY-MM',
  /**
   *  FULL DOT 형태의 날짜 형식
   */
  FULL_DOT_FORMAT: 'YYYY.MM.DD HH:mm:ss',
  /**
   *  년.월.일 시:분 형태의 날짜 형식
   */
  YMD_HM_DOT_FORMAT: 'YYYY.MM.DD HH:mm',
  /**
   *  년.월.일 형태의 날짜 형식
   */
  YMD_DOT_FORMAT: 'YYYY.MM.DD',
  /**
   *  년.월 형태의 날짜 형식
   */
  YM_DOT_FORMAT: 'YYYY.MM',
  /**
   *  시:분 형태의 날짜 형식
   */
  HM_FORMAT: 'HH:mm',
  /**
   *  월/일 형태의 날짜 형식
   */
  MD_SLASH_FORMAT: 'MM/DD',
  /**
   *  요일 형태의 형식
   */
  DAY_OF_THE_WEEK_FORMAT: 'dddd',
  /**
   *  AM/PM 형태의 형식
   */
  AM_PM_FORMAT: 'a h',
  /**
   *  UTC 형식
   */
  UTC_FORMAT: 'YYYY-MM-DD"T"HH:mm:ss.SSS"Z"',
};

/**
 *  엑셀 업로드 타입
 */
export const EXCEL_UPLOAD_TYPE = {
  BUTTON: 0,
  DRAG_DROP: 1,
};

/**
 *  양의 무한대의 타임스탬프 값
 */
export const MAXIMUM_TIMESTAMP = 8640000000000000;

/**
 *  음의 무한대의 타임스탬프 값
 */
export const MINIMUM_TIMESTAMP = -8640000000000000;

/**
 *  날짜 선택 버튼의 기본 버튼명
 */
export const DATE_PICKER_DEFAULT_BUTTON_TEXT = '날짜 선택';

/**
 *  날짜 선택 placeholder 의 기본 값
 */
export const DATE_PICKER_DEFAULT_PLACEHOLDER_TEXT = 'YYYY년 M월 D일';

/**
 *  FULL DASH 형태의 날짜 형식 placeholder 텍스트
 */
export const DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  체크박스, 라디오 박스 전체 타입
 */
export const CHECK_RADIO_BOX_ALL_TYPE = -1;

/**
 *  체크박스, 라디오 박스 전체 타입 텍스트
 */
export const CHECK_RADIO_BOX_ALL_TYPE_TEXT = '전체';

/**
 *  태그 거절 사유 최대 길이
 */
export const MAXIMUM_NUMBER_OF_TAG_REJECT_REASON = 700;

/**
 *  송장번호 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_INVOICE_NUMBER = 30;

/**
 * all, valid, invalid 셀렉터
 */
export const VALID_FILTER = {
  ALL: 'all',
  VALID: 'valid',
  INVALID: 'invalid',
};

export const HTTP_METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
  PATCH: 'patch',
  HEAD: 'head',
  OPTIONS: 'options',
  CONNECT: 'connect',
  TRACE: 'trace',
};
